import React, { useState } from 'react'
// import { useTranslation } from 'react-i18next'
// import { Button } from '@shopify/polaris'
// import { ImportMinor } from '@shopify/polaris-icons'
import _ from 'lodash'
// import JSZip from 'jszip'
// import FileSaver from 'file-saver'
// import utils from '../../../../../../utils/utils'
// * 页面组件
import PreviewImage from '../../../../../../components/PreviewImage'
/**
 *
 * @param {Object} data 商品详情
 * @param {Function} setRuleForm 修改商品详情方法
 * @param {onSave} onSave 保存
 * @returns
 */
const Media = ({ data, setRuleForm, onSave,title }) => {
	// const { t } = useTranslation()

	// 下载图片loading
	// const [loading, setLoading] = useState(false)

	// 图片预览
	const [showPreview, setShowPreview] = useState(false)
	const [previewIndex, setPreviewIndex] = useState(0)
	const [previewList, setPreviewList] = useState([])

	// 图片预览方法
	const handlePreview = (item, index) => {
		// console.log('item', item.src)
		setShowPreview(true)
		setPreviewIndex(index)
		const list = _.map(data.ProductImages, (item, index) => {
			return {
				keyIndex: index,
				src: item.src
			}
		})
		setPreviewList(list)
	}

	// 选择图片
	const handleSelectImage = async (item) => {
		// 如果已经导入，则不可修改
		if (data.status) {
			return
		}
		const imageList = _.cloneDeep(data.ProductImages)
		_.forEach(imageList, (el) => {
			if (el.id === item.id) {
				el.selected = el.selected === 1 ? 0 : 1
			}
		})
		await setRuleForm((preState) => {
			let currentData = preState.ProductImages
			let param = {...currentData,ProductImages:imageList}
			const params = {...preState,Media:param}
			return params;
		})
		onSave('images')
	}

	// 批量下载图片
	// const downloadImage = () => {
	// 	setLoading(true)
	// 	try {
	// 		let zipName = title // zip压缩包名称 (处理特殊字符并移除多于空格，只保留一个)
	// 		zipName = zipName.replace(/[/*|:<>?"\\]/gi, '')
	// 		zipName = zipName.replace(/[\r\n]/g, ' ')
	// 		zipName = zipName.replace(/\s+/g, ' ')

	// 		let zip = new JSZip()
	// 		const imageList = _.map(data.ProductImages, 'src')
	// 		for (let i = 0; i < imageList.length; i++) {
	// 			let src = imageList[i]
	// 			let tempImage = new Image()
	// 			tempImage.src = src
	// 			tempImage.crossOrigin = '*' // 解决跨域问题：图片链接与当前域名不匹配
	// 			tempImage.onload = () => {
	// 				zip.file(zipName + '_' + (i + 1) + '.jpg', utils.getBase64Image(tempImage).substring(22), {
	// 					base64: true
	// 				})
	// 			}
	// 		}
	// 		setTimeout(() => {
	// 			zip.generateAsync({ type: 'blob' }).then(function (content) {
	// 				console.log(content);
	// 				FileSaver.saveAs(content, zipName + '-' + new Date().valueOf() + '.zip')
	// 			})
	// 			setLoading(false)
	// 		}, 1000)
	// 	} catch (error) {
	// 		alert(t('Incorrect image download.'))
	// 		setLoading(false)
	// 	}
	// }

	return (
		<div className="product-media">
			<div className="mb-4">
				{/* <Button
					icon={ImportMinor}
					variant='plain'
					textAlign="left"
					onClick={downloadImage}
					disabled={loading}
				>
					{t('Click here to download all images')}
				</Button> */}
			</div>
			<ul className="product-media-list">
				{_.map(data.ProductImages, (item, index) => {
					return (
						<li key={index} className="product-media-image">
							<div className={item.selected === 1 ? 'image_box image--selected' : 'image_box'}>
								<div className="image_status">
									<span className="sign_icon"></span>
								</div>
								<div className="image_box_overlay" onClick={() => handleSelectImage(item)}>
									<div className="image_preview_action">
										<div
											className="image_preview__button"
											onClick={(event) => {
												event.stopPropagation()
												handlePreview(item, index)
											}}
										>
											<svg
												viewBox="64 64 896 896"
												data-icon="eye"
												width="1em"
												height="1em"
												fill="currentColor"
												aria-hidden="true"
												focusable="false"
											>
												<path
													fill="#fff"
													d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
												></path>
											</svg>
										</div>
									</div>
								</div>
								<img src={item.src} className="single_product_image" alt="product" />
							</div>
						</li>
					)
				})}
			</ul>

			{/* 图片预览 */}
			<PreviewImage
				isShow={showPreview}
				index={previewIndex}
				imageList={previewList}
				onClose={() => setShowPreview(false)}
			/>
		</div>
	)
}

export default Media
